import React from 'react';
import Hero from '../components/Home/Hero';
import FeaturedProjects from '../components/Home/FeaturedProjects';
import Services from '../components/Home/Services';
import Testimonials from '../components/Home/Testimonials';
import Footer from '../components/Layout/Footer';
import Header from '../components/Layout/Header';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <FeaturedProjects />
        <Services />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
